import type { GenericAction } from '@/types/helpers'
import type { AttachmentItem, StorageLimits } from '@/types/models'
import type { PERMISSION_VALUE } from '../../../permissions'
import type { PROJECT_PERMISSION } from '../../../permissions/project/permissions'

export enum UserActions {
  SET_PERMISSIONS = 'UserActions: SET_PERMISSIONS',
  SET_STORAGE_LIMITS = 'UserActions: SET_STORAGE_LIMITS',
  INCREASE_STORAGE_LIMITS = 'UserActions: INCREASE_STORAGE_LIMITS',
  DECREASE_STORAGE_LIMITS = 'UserActions: DECREASE_STORAGE_LIMITS',
}

export type SetStorageLimits = GenericAction<
  UserActions.SET_STORAGE_LIMITS,
  StorageLimits
>

export type SetPermissions = GenericAction<
  UserActions.SET_PERMISSIONS,
  Record<PROJECT_PERMISSION, PERMISSION_VALUE> | null
>

export type IncreaseStorageLimits = GenericAction<
  UserActions.INCREASE_STORAGE_LIMITS,
  AttachmentItem[]
>

export type DecreaseStorageLimits = GenericAction<
  UserActions.DECREASE_STORAGE_LIMITS,
  AttachmentItem[]
>

export type UserActionsType =
  | SetPermissions
  | SetStorageLimits
  | IncreaseStorageLimits
  | DecreaseStorageLimits
